import { useReactiveVar } from '@apollo/client';
import { LivenessCapture } from '../../../LivenessCapture';
import {
  identityVerificationDialogVar,
  setIdentityVerificationDialogVar,
} from '../IdentityVerificationDialog.vars';

export function CaptureLiveness() {
  const identityVerificationDialog = useReactiveVar(
    identityVerificationDialogVar,
  );
  const { selectedIDType, verificationId } = identityVerificationDialog;
  const workflow = identityVerificationDialog[selectedIDType];

  return (
    <LivenessCapture
      verificationId={verificationId}
      onSuccess={(imageUrl) => {
        setIdentityVerificationDialogVar({
          showSummary: true,
          [selectedIDType]: {
            ...workflow,
            selfie: { imageData: { dataUrl: imageUrl, width: 0, height: 0 } },
          },
        });
      }}
      onBack={() => {
        if (!selectedIDType) return;
        const { currentStep } = workflow;
        setIdentityVerificationDialogVar({
          [selectedIDType]: {
            ...workflow,
            currentStep: currentStep - 1,
          },
        });
      }}
    />
  );
}
